import React from 'react';
import PropTypes from 'prop-types';

const LoginForm = ({
  renderValidationError,
  authenticityToken,
  handleSubmit,
  onChange,
  loginAction,
  newUserConfimationPath,
  newUserPasswordPath,
  loginButtonDisabled,
}) => (
  <form
    method="POST"
    action={loginAction}
    className="form sign-in"
    acceptCharset="UTF-8"
    onSubmit={handleSubmit}
    id="login-form"
  >
    <input name="utf8" type="hidden" value="✓" />
    <input
      type="hidden"
      name="authenticity_token"
      value={authenticityToken}
    />

    <div className="clearfix px2">
      <div className="col col-12 md-col-12 mt1 px1">
        <input
          type="text"
          className="input input-pill"
          name="user[login]"
          placeholder="Email"
          id="loginEmail"
          is-required="true"
          onChange={onChange}
        />
      </div>
      <div className="col col-12 md-col-12 mt1 px1">
        <input
          type="password"
          className="input input-pill"
          name="user[password]"
          placeholder="Password"
          id="loginPassword"
          is-required="true"
          onChange={onChange}
        />
      </div>
      <div className="col col-12 md-col-12 mt1 px1">
        <div className="clearfix">
          <div className="col col-12 md-col-9">
            <input
              type="checkbox"
              name="user[remember_me]"
              id="remember_me"
            />
            <label htmlFor="remember_me">Remember Me</label>
          </div>
          <div className="col col-12 md-col-3 right-align">
            <button
              type="submit"
              id="login"
              className="btn-pill btn btn-primary"
              disabled={loginButtonDisabled}
            >
                Login
            </button>
          </div>

        </div>
      </div>
      <div className="col col-12 md-col-12 mt1 px1">
        <a href={newUserPasswordPath}>Forgot your password?</a>
        <br />
        <a href={newUserConfimationPath}>Didn't receive confirmation instructions?</a>
      </div>
    </div>
  </form>
);

LoginForm.propTypes = {
  renderValidationError: PropTypes.func.isRequired,
  authenticityToken: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  loginAction: PropTypes.string.isRequired,
  newUserPasswordPath: PropTypes.string.isRequired,
  newUserConfimationPath: PropTypes.string.isRequired,
  loginButtonDisabled: PropTypes.string.isRequired,
};
export default LoginForm;
